module.exports = __webpack_public_path__ + "static/media/5ed7a45372f4e5e57a748790.ec0a3c26.png";